import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class ProfileBuilderService {
  createGenInfoObj(payload) {
    let genInfoObj = _.clone(payload);
    genInfoObj = _.pick(genInfoObj, [
      'ahaMember',
      'ahaId',
      'medicareProviderId',
      'name',
      'phone',
      'url',
      'control',
      'service'
    ]);

    if (payload.system && payload.system.name && !_.isEmpty(payload.system.name)) {
      genInfoObj['system'] = payload.system.name;
      genInfoObj['systemId'] = payload.system.systemId;
    }

    if (payload.parentUnit && !_.isEmpty(payload.parentUnit)) {
      genInfoObj['parentAhaId'] = payload.parentUnit.ahaId;
      genInfoObj['parentName'] = payload.parentUnit.parentName;
    }
    return genInfoObj;
  }

  createSystemGenInfoObj(payload) {
    let sysGenInfoObj = _.clone(payload);
    sysGenInfoObj = _.pick(sysGenInfoObj, [
      'name',
      'phone',
      'bedCount',
      'facilityCount',
      'region',
      'clusterCode',
      'control',
      'url'
    ]);

    return sysGenInfoObj;
  }

  createCSuiteObj(payload) {
    if ('individuals' in payload && !_.isEmpty(payload.individuals)) {
      let individuals = _.clone(payload.individuals);
      return individuals;
    }
  }

  createAddressObj(payload) {
    if ('locationAddress' in payload && !_.isEmpty(payload.locationAddress)) {
      let addressObj = _.clone(payload.locationAddress);
      addressObj = _.omitBy(addressObj, _.isNil);
      addressObj = _.omitBy(addressObj, _.isEmpty);

      return addressObj;
    }
  }

  createCodesObj(payload, typeOfCode) {
    let codesObj = _.clone(payload[typeOfCode]);
    return codesObj;
  }

  createUtilizationObj(payload) {
    if ('utilization' in payload && !_.isEmpty(payload.utilization)) {
      let utilizationObj = _.clone(payload.utilization[0].util);

      if ('nonreporting' in payload && !_.isEmpty(payload.nonreporting)) {
        if (payload.nonreporting === 'true') {
          var nonReporObj = {
            label: 'Reporting',
            text: 'No'
          };
        } else {
          var nonReporObj = {
            label: 'Reporting',
            text: 'Yes'
          };
        }
        utilizationObj.push(nonReporObj);
      }

      if ('nursingBeds' in payload && !_.isEmpty(payload.nursingBeds)) {
        if (payload.nursingBeds !== 'NaN') {
          var nursBedsObj = {
            label: 'Nursing Beds',
            text: payload.nursingBeds
          };
          utilizationObj.push(nursBedsObj);
        }
      }

      return utilizationObj;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/profile-builder.service.ts